import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Admin = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { admins } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "username",
          icon: 'fa-solid fa-cube',
          type: 'text',
          placeholder: 'Enter Username',
        },
        {
          name: "role",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Role',
        },
        {
          name: "countries",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Countries'
        },
        {
          name: "passwrd",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Password',
        },
        {
            name: "permissions",
            icon: 'fa-solid fa-user',
            type: 'text',
            placeholder: 'Enter Permissions',
          },
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['Admin ID', 'Username', 'Role', 'Countries', 'Permissions', 'Password']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/admins.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Admin' name='Admins'/>
        <div className="w3-container">
        <Table tableName='admins' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Admin Members' columns={userColumns} data={admins ? admins : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Admin